<template>
  <main class="marketing-email-create-send">
    <app-form @submit="send">
      <marketing-form-send v-model="sendSchedule" />

      <div class="marketing-email-create-send-actions">
        <button class="btn btn-outline btn-extra-round"
                type="button"
                @click="saveContent">
          {{$t('message.marketingGenerics.message.saveDraft')}}
        </button>

        <button class="btn btn-primary btn-extra-round"
                type="submit">
            {{$t('message.generics.message.advance')}}
        </button>
      </div>
    </app-form>
  </main>
</template>

<script>
import MarketingFormSend from "@components/modules/marketing/generic/form/send/MarketingFormSend";
import AppForm from "@components/form/Form.vue";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppForm,
    MarketingFormSend,
  },

  data() {
    return {
      sendSchedule: {
        schedule: {
          date: undefined,
          hour: undefined,
        },
        scheduleType: undefined,
      },
    };
  },

  created() {},

  computed: {
    item() {
      return this.$store.state.marketing.email.create.item ? 
      this.$store.state.marketing.email.create.item :
      this.itemInSessionStorage
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
  },

  mixins: [],

  methods: {
    async send() {
      await this.$api.marketing.email.send.send({
        emailId: this.item.id,
        schedulerDate: this.getFormatedSchedulerDate(),
      });

      this.$router.push({
        path: "/marketing/email",
      });
    },
    async saveContent() {
      await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        data: {
          ...this.item,
          schedulerDate: this.getFormatedSchedulerDate(),
        },
      });

      this.$router.push({
        path: "/marketing/email",
      });

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t('message.successMessages.message.draftSaved'),
      });
    },
    getFormatedSchedulerDate() {
      let schedulerDate;

      if (this.sendSchedule.scheduleType === "SCHEDULE") {
        schedulerDate = `${this.sendSchedule.schedule.date} ${this.sendSchedule.schedule.hour}:00`;
      }

      return schedulerDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-create-send {
  .marketing-email-create-send-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    padding: 50px 0;
  }
}
</style>
